import { createReducer, on } from '@ngrx/store';
import { setTransitionAnalyses } from './transition-analyses.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const transitionAnalyses = createReducer({}, on(setTransitionAnalyses, (state, action) => {
    return action.transitionAnalyses;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
